import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { fileToBase64 } from '../../../../@core/utils/base64-file';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { Base64FileData } from '../pd-collect-data.store';

@Component({
  selector: 'app-pd-document-file',
  templateUrl: './pd-document-file.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdDocumentFileComponent {
  @ViewChild(FileUpload) fileUpload!: FileUpload;
  @Output() selectFile = new EventEmitter<Base64FileData>();
  @Output() clearedFile = new EventEmitter<void>();
  public blocked = false;

  constructor(private readonly cdRef: ChangeDetectorRef) {}

  public onFileSelected() {
    this.blocked = true;
    this.cdRef.markForCheck();
    fromPromise(fileToBase64(this.fileUpload.files[0])).subscribe((base64) => {
      this.selectFile.emit({
        name: this.fileUpload.files[0].name as string,
        base64,
        mimeType: this.fileUpload.files[0].type as string,
      });
      this.blocked = false;
      this.cdRef.markForCheck();
    });
  }

  clearFiles() {
    this.fileUpload.clear();
    this.clearedFile.emit();
  }
}
